<template>
  <div v-click-outside="close" class="dropdown text-center"
       :class="{'displayed':isOpen, 'cursor-pointer': !disabled, 'cursor-not-allowed': disabled}">
    <div class="title z-10" @click="isOpen ? close() : openSelection()"
         :class="{'bg-white':isOpen}">
      <div
        class="bg-classen__secondary title-text border-shadow border-classen__secondary bg-white grid grid-cols-5"
        :class="{'rounded-20':(rounded)}">
        <p class="col-span-4 overflow-hidden whitespace-nowrap overflow-ellipsis text-left pl-5"
           :class="{'placeholder':(selectedOption.value === '')}">
          {{ selectedOption.name }}
        </p>
        <p class="self-center justify-self-end pr-5">
          <span v-show="!isOpen"><svg class="fas fa-angle-down"></svg></span>
          <span v-show="isOpen"><svg class="fas fa-angle-up"></svg></span>
        </p>
      </div>
    </div>
    <div class="dropdown-content pr-3 py-1">
      <div class="grid h-full pl-5">
        <div class="text-left options_div pr-2 overflow-y-auto grid">
          <p v-for="option in options" @click="setCurrentOption(option)"
             class="border-b border-classen__secondary cursor-pointer hover:bg-classen__secondary option">
            {{ option.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ClickOutside from 'vue-click-outside'
import EventBus from "../../services/EventBus";
import Decors from "./Decors/Decors";
import Input from "../form/Input";
import getTranslation from "../../mixins/getTranslation";
import Button from "../Button";

export default {
  name: "OptionDropdown",

  components: {Button, Input, Decors},

  props: {
    selectedOption: {required: true},
    options: {required: true},
    rounded: {required: false},
    disabled: {required: false, default: false},
  },

  created() {
    EventBus.listen('close-selection', this.close);
  },

  destroyed() {
    EventBus.destroy('close-selection', this.close);
  },

  mixins: [getTranslation],

  data() {
    return {
      isOpen: false,
      selected: this.selected,
      hasError: true,
    }
  },

  watch: {
    selected() {
      this.$emit('update:selectedOption', this.selected)
    }
  },

  computed: {},

  methods: {
    setCurrentOption(option) {
      this.selected = option
      this.isOpen = false;
    },

    close() {
      this.isOpen = false
    },

    openSelection() {
      if (this.disabled) {
        return;
      }

      EventBus.fire('close-menus');
      EventBus.fire('close-selection');
      EventBus.fire('close-nav');
      this.isOpen = true;
    },
  },

  directives: {
    ClickOutside
  }
}
</script>

<style scoped>
* {
  user-select: none;
}

.title-text {
  height: 35px;
  line-height: 35px;
}

.title {
  height: 35px;
  border-radius: 20px 20px 0 0;
}

.displayed > .title {
  border: 1px solid #EAEBEC;
  border-bottom: none;
}

.dropdown {
  position: relative;
  min-width: 250px;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #FFFFFF;
  width: 100%;
  z-index: 1;
  border-radius: 0 0 20px 0;
  border: 1px solid #EAEBEC;
  border-top: none;
}

.displayed .dropdown-content {
  display: block;
}

.options_div {
  max-height: 125px;
}

.options_div:last-child {
  border: none;
}

.placeholder {
  color: #C0C0C0;
}

.option:last-child {
  border: none
}

.option:last-child:hover {
  border-radius: 0 0 20px 0;
}
</style>
